var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css, } from 'styled-components';
import { margin } from 'styled-system';
import { muiCheckMark } from '@ally/metronome-icons';
import { Icon } from '../Icon';
import { get, propsToForward } from '../tools/utils';
var inputStyles = css(function (_a) {
    var $isChecked = _a.$isChecked, $isDisabled = _a.$isDisabled, colors = _a.theme.colors;
    if ($isDisabled) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        cursor: not-allowed;\n        background-color: ", ";\n        border: none;\n      "], ["\n        cursor: not-allowed;\n        background-color: ", ";\n        border: none;\n      "])), get.colors('periwinkle-300'));
    }
    if ($isChecked) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        cursor: pointer;\n        background-color: ", ";\n        border: none;\n      "], ["\n        cursor: pointer;\n        background-color: ", ";\n        border: none;\n      "])), get.colors('bluesuedeshoes'));
    }
    return '';
});
var disabledLabelStyles = css(function (_a) {
    var $isDisabled = _a.$isDisabled;
    if ($isDisabled) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        cursor: not-allowed;\n        color: ", ";\n      "], ["\n        cursor: not-allowed;\n        color: ", ";\n      "])), get.colors('gray-700'));
    }
    return '';
});
var Label = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  height: fit-content;\n  cursor: pointer;\n  align-items: center;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  height: fit-content;\n  cursor: pointer;\n  align-items: center;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  ", ";\n"])), get.colors('slate-5'), function (_a) {
    var font = _a.theme.font;
    return font.body.sm.size;
}, function (_a) {
    var font = _a.theme.font;
    return font.body.sm.lineHeight;
}, disabledLabelStyles);
var Input = styled.input.withConfig({
    shouldForwardProp: propsToForward,
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: ", ";\n  height: 24px;\n  box-sizing: border-box;\n  width: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  appearance: none;\n  margin-right: ", ";\n  flex-shrink: 0;\n\n  &::-ms-check {\n    color: transparent;\n  }\n\n  ", "\n"], ["\n  cursor: ", ";\n  height: 24px;\n  box-sizing: border-box;\n  width: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  appearance: none;\n  margin-right: ", ";\n  flex-shrink: 0;\n\n  &::-ms-check {\n    color: transparent;\n  }\n\n  ", "\n"])), function (props) { return (props.$isDisabled ? 'not-allowed' : 'pointer'); }, function (props) {
    return props.$isDisabled
        ? get.colors('slate-1')(props)
        : get.colors('white')(props);
}, get.colors('periwinkle-500'), get.space('md'), inputStyles);
var CheckContainer = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 24px;\n  width: 24px;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 24px;\n  width: 24px;\n  flex-shrink: 0;\n"])));
var Check = function (_a) {
    var isChecked = _a.isChecked;
    if (isChecked) {
        return (React.createElement(CheckContainer, null,
            React.createElement(Icon, { icon: muiCheckMark, fill: "white", size: "sm", ariaHidden: true })));
    }
    return null;
};
var Checkbox = React.forwardRef(function (_a, ref) {
    var inputId = _a.inputId, label = _a.label, name = _a.name, isChecked = _a.isChecked, onChange = _a.onChange, className = _a.className, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, rest = __rest(_a, ["inputId", "label", "name", "isChecked", "onChange", "className", "isDisabled"]);
    return (React.createElement(Label, { htmlFor: inputId, "$isChecked": isChecked, "$isDisabled": isDisabled, className: className },
        React.createElement(Input, __assign({ ref: ref, id: inputId, type: "checkbox", name: name, checked: isChecked, value: "".concat(isChecked), onChange: onChange, tabIndex: 0, "$isDisabled": isDisabled, "$isChecked": isChecked, disabled: isDisabled, "aria-checked": isChecked, "aria-disabled": isDisabled }, rest)),
        React.createElement(Check, { isChecked: isChecked }),
        label));
});
var CheckboxWithMarginProps = styled(Checkbox)(margin);
export { CheckboxWithMarginProps as Checkbox, Checkbox as CheckboxForProps };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Checkbox.js.map